import React, { useContext, useEffect, useState } from 'react';
import './Landing.scss';
import MyContext from '../../../Uttis/MyContext';

function HeroSection() {
  const [scrollY, setScrollY] = useState(0);
  const { handleselect } = useContext(MyContext);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const translateY = Math.max(0, scrollY * 0.3); // smoother parallax

  return (
    <div className="hero-container">
      {/* Pentagon animation */}
      <div className="contact-main" style={{ transform: `translateY(-${translateY}px)` }}>
        {[0, 1, 2, 3, 4].map((i) => (
          <svg
            key={i}
            className={`pentagon-border pentagon-${i}`}
            viewBox="0 0 100 100"
          >
            <polygon
              points="50,1 98,38 79,95 21,95 2,38"
              stroke="rgb(0, 174, 255)"
              strokeWidth="0.6"
              fill="none"
            />
          </svg>
        ))}
      </div>

      {/* Hero content */}
      <div className="hero-content" style={{ transform: `translateY(-${translateY / 2}px)` }}>
        <h1 className="hero-title">
          <span>Turn</span> your ideas into <span>real-world</span> solutions.
        </h1>
        <p className="hero-subtitle">
          Learn, build, and grow with our professional <strong>learning</strong> and
          <strong> internship</strong> programs.
        </p>

 <div className="hero-buttons">
  <button
    className="hero-button primary"
    onClick={() => handleselect("it-training")}
  >
    Choose Course
  </button>

  <button
    className="hero-button secondary"
    onClick={() => handleselect("it-internship")}
  >
    Apply for Internship
  </button>
</div>
      </div>
    </div>
  );
}

export default HeroSection;
